"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'onboarding.warning.name.required': 'Por favor proporcione al menos un nombre de avatar para continuar.',
};
